import {
    CHAT_CONTACT_LIST, START_CONVERSATION, SEND_MESSAGE_TO_XMPP,
    CONNECT_XMPP, RECEIVED_MESSAGE_FROM_XMPP, PUSH_MESSAGE, PUSH_BULK_MESSAGE,
    FILE_UPLOADED_ON_SUCCESS, FILE_UPLOADING, CONNECTED_XMPP, CHAT_PRESENT, CHAT_EG_LIST, GET_USER_LIST,
    GET_UNREAD_MESSAGE_COUNT
} from "../constants/action-types";
import { getLoginId } from "../helpers/session";
import { capitalize, getNameFromEmail, getFileType } from "../helpers/common";
import moment from 'moment-timezone';

const initialState = {
    isConnected: false,
    isPresent: false,
    profile: {
        nickName: null,
        email: null,
        status: 'online',
        contactId: null,
        farmId: null,
        unreadContacts: 0
    },
    farmId: null,
    egList: [],
    contactList: [],
    userList: [],
    messageHistory: {},
    current: {
        contactId: null
    },
    userContactList: [],
    isStopUnreadMessageCount: false,
    unreadMessageCount: 0
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CONNECT_XMPP:
            const loginId = getLoginId();
            state = {
                ...state, profile: {
                    ...state.profile, email: loginId, contactId: action.contactId, farmId: action.farmId,
                    nickName: loginId ? capitalize(loginId.replace(/@.*/, "")) : "",
                }
            };
            break;
        case CONNECTED_XMPP:
            state = { ...state, isConnected: true };
            break;
        case CHAT_EG_LIST:
            state = { ...state, farmId: action.farmId, egList: action.egList };
            break;
        case CHAT_CONTACT_LIST:
            let contactList = action.contactList ? action.contactList : initialState.contactList;
            let userList = action.userList ? action.userList : initialState.userList;

            contactList = contactList.map(e => ({
                ...e, nickName: getNameFromEmail(e.name),
                ...!e.message ? { message: { preview: null, ts: null, messageType: 0, unreadCount: 0 } } : {}
            }));

            userList = userList.map(e => ({ ...e, nickName: getNameFromEmail(e.name) }));

            state = { ...state, contactList, userList };
            break;
        case SEND_MESSAGE_TO_XMPP:
            state = { ...state, ...pushMessage(state, action) };
            state = { ...state, ...updateContactList(state) };
            break;
        case RECEIVED_MESSAGE_FROM_XMPP:
            state = { ...state, ...pushMessage(state, action) };
            state = { ...state, ...updateContactList(state) };
            break;
        case PUSH_MESSAGE:
            state = { ...state, ...pushMessage(state, action) };
            if (action.message && action.message.messageType === 2)
                state = { ...state, ...updateContactList(state) };
            break;
        case PUSH_BULK_MESSAGE:
            state = { ...state, ...pushBulkMessage(state, action) };
            const received = action.messages.filter(e => e.messageType === 2);
            if (received.length > 0) state = { ...state, ...updateContactList(state) };
            break;
        case START_CONVERSATION:
            state = { ...state, current: { contactId: action.to }, ...updateReadMessage(state, action.to) };
            break;
        case GET_USER_LIST:
            const list = action.payload;
            state = { ...state, userContactList: list };
            break;
        case GET_UNREAD_MESSAGE_COUNT:
            let count = action.payload.unread_count;
            const isClearInterval = action.isClearInterval;
            count = count ? count : 0;
            state = { ...state, unreadMessageCount: count, isStopUnreadMessageCount: isClearInterval ? isClearInterval : false };
            break;
        case FILE_UPLOADING:
            state = { ...state, ...updateMessage(state, action) };
            break;
        case FILE_UPLOADED_ON_SUCCESS:
            state = { ...state, ...updateMessage(state, action) };
            break;
        case CHAT_PRESENT:
            state = { ...state, isPresent: action.isPresent }
            break;
        default:
            break;
    }

    return state;
}

const pushBulkMessage = (state, action) => {
    let { messageHistory } = state;
    for (const message of action.messages) {
        const history = pushMessage(state, { message });
        if (history) messageHistory = history.messageHistory;
    }
    return { messageHistory };
}

const pushMessage = (state, action) => {
    if (!action.message.hasOwnProperty("body")) return;
    if (!action.message.body.id) return;

    const { messageHistory } = state;
    const { messageType } = action.message;
    const contactId = (messageType === 1) ? action.message.to : action.message.from;
    if (messageHistory[contactId] && messageHistory[contactId].length > 0) {
        const foundMessages = messageHistory[contactId].filter(e => e.id === action.message.body.id);
        if (foundMessages.length > 0) return;
    }

    const { body } = action.message;
    let defaults = null;

    if (messageType === 1) {
        defaults = { id: null, messageType, ts: null, contentType: null, content: null, delivered: 0 };
    } else if (messageType === 2 && action.message.to === state.profile.contactId) {
        defaults = { id: null, messageType, ts: null, contentType: null, content: null, read: 0, authorId: null, nickName: null };

        const authorId = (action.message.chatType === "group") ? action.message.authorId : contactId;
        const findContact = state.userList.filter(e => e.contact_id === authorId);

        if (findContact.length > 0 && findContact[0].avatar) body["avatar"] = findContact[0].avatar;
        body["nickName"] = (findContact.length > 0) ? findContact[0].nickName : null;
        body["authorId"] = (action.message.chatType === "group") ? action.message.authorId : null;

        const msgTime = moment.utc(action.message.body.ts).valueOf();
        const curTime = moment.utc().valueOf();
        const time = (curTime - msgTime) / (1000);
        if (time <= 1800) body["read"] = (state.isPresent && contactId === state.current.contactId) ? 1 : 0;
        else body["read"] = 1;
    }

    if (!messageHistory[contactId]) messageHistory[contactId] = [];
    messageHistory[contactId].push({ ...defaults, ...body });
    messageHistory[contactId].sort((a, b) => a.ts - b.ts);

    return { messageHistory };
}

const updateContactList = (state) => {
    let unreadContacts = 0;
    const contactList = state.contactList.map(item => {
        const messages = state.messageHistory[item.contact_id] ? state.messageHistory[item.contact_id] : null;
        if (messages) {
            const message = messages[messages.length - 1];
            const unreadCount = messages.filter(e => e.read === 0 && e.messageType === 2).length;
            if (unreadCount > 0) unreadContacts++;

            let preview = message.content;
            if (Array.isArray(message.attachments) && message.attachments.length > 0) {
                const attachment = message.attachments[message.attachments.length - 1];
                preview = getFileType(attachment.type);
            }

            return {
                ...item, message: {
                    ...item.message, unreadCount, preview, authorNickName: message.nickName,
                    ts: message.ts, messageType: message.messageType
                }
            }
        }
        return item;
    }).sort((a, b) => b.message.ts - a.message.ts);

    return { contactList, profile: { ...state.profile, unreadContacts } };
}

const updateReadMessage = (state, to) => {
    const { messageHistory, contactList } = state;
    const messages = state.messageHistory[to];
    if (!messages) return;

    const unreadCount = messages.filter(e => e.read === 0 && e.messageType === 2).length;
    if (unreadCount === 0) return;

    messages.forEach(e => e["read"] = 1);

    contactList.forEach(e => {
        if (e.contact_id === to) {
            e.message["unreadCount"] = 0;
            return false;
        }
    });

    return {
        messageHistory: { ...messageHistory },
        contactList: [...contactList],
        profile: { ...state.profile, unreadContacts: (state.profile.unreadContacts - 1) }
    };
}

const updateMessage = (state, action) => {
    if (!action.body || !state.messageHistory[action.contactId]) return;

    const messages = state.messageHistory[action.contactId];
    messages.forEach(msg => {
        if (msg.id !== action.messageId) return;
        msg = { ...msg, ...action.body };
    });

    return { messageHistory: { ...state.messageHistory, [action.contactId]: messages } };
}